import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { Box, Modal, IconButton, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../utils/styles/Contacto/ContactoStyle.scss";

// Importaciones de imágenes
import img1 from "../../utils/img/Galeria/1.jpg";
import img2 from "../../utils/img/Galeria/2.jpg";
import img3 from "../../utils/img/Galeria/3.jpg";
import img4 from "../../utils/img/Galeria/4.jpg";
import img5 from "../../utils/img/Galeria/5.jpg";
import img6 from "../../utils/img/Galeria/6.jpg";
import img7 from "../../utils/img/Galeria/7.jpg";
import img8 from "../../utils/img/Galeria/8.jpg";
import img9 from "../../utils/img/Galeria/9.jpg";
import img10 from "../../utils/img/Galeria/10.jpg";
import img11 from "../../utils/img/Galeria/11.jpg";
import img12 from "../../utils/img/Galeria/12.jpg";
import img13 from "../../utils/img/Galeria/13.jpg";
import img14 from "../../utils/img/Galeria/14.jpg";
import img15 from "../../utils/img/Galeria/15.jpg";
import img16 from "../../utils/img/Galeria/16.jpg";
import img17 from "../../utils/img/Galeria/17.jpg";
import img18 from "../../utils/img/Galeria/18.jpg";
import img19 from "../../utils/img/Galeria/19.jpg";
import img20 from "../../utils/img/Galeria/20.jpg";
import img21 from "../../utils/img/Galeria/21.jpg";
import img22 from "../../utils/img/Galeria/22.jpg";
import img23 from "../../utils/img/Galeria/23.jpg";
import img24 from "../../utils/img/Galeria/24.jpg";
import img25 from "../../utils/img/Galeria/25.jpg";
import img26 from "../../utils/img/Galeria/26.jpg";
import img27 from "../../utils/img/Galeria/27.jpg";
import img28 from "../../utils/img/Galeria/28.jpg";
import img29 from "../../utils/img/Galeria/29.jpg";
import img30 from "../../utils/img/Galeria/30.jpg";
import img31 from "../../utils/img/Galeria/31.jpg";
import img33 from "../../utils/img/Galeria/33.jpg";
import img34 from "../../utils/img/Galeria/34.jpg";
import img35 from "../../utils/img/Galeria/35.jpg";
import img36 from "../../utils/img/Galeria/36.jpg";

const itemData = [
  { img: img1, title: "img1" },
  { img: img2, title: "img2" },
  { img: img3, title: "img3" },
  { img: img4, title: "img4" },
  { img: img5, title: "img5" },
  { img: img6, title: "img6" },
  { img: img7, title: "img7" },
  { img: img8, title: "img8" },
  { img: img9, title: "img9" },
  { img: img10, title: "img10" },
  { img: img11, title: "img11" },
  { img: img12, title: "img12" },
  { img: img13, title: "img13" },
  { img: img14, title: "img14" },
  { img: img15, title: "img15" },
  { img: img16, title: "img16" },
  { img: img17, title: "img17" },
  { img: img18, title: "img18" },
  { img: img19, title: "img19" },
  { img: img20, title: "img20" },
  { img: img21, title: "img21" },
  { img: img22, title: "img22" },
  { img: img23, title: "img23" },
  { img: img24, title: "img24" },
  { img: img25, title: "img25" },
  { img: img26, title: "img26" },
  { img: img27, title: "img27" },
  { img: img28, title: "img28" },
  { img: img29, title: "img29" },
  { img: img30, title: "img30" },
  { img: img31, title: "img31" },
  { img: img33, title: "img33" },
  { img: img34, title: "img34" },
  { img: img35, title: "img35" },
  { img: img36, title: "img36" },
];

const Gallery = () => {
  const [open, setOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState("");

  // Manejar las columnas según el tamaño de la pantalla
  const isSmall = useMediaQuery("(max-width:600px)"); // 1 columna en móviles
  const isMedium = useMediaQuery("(max-width:960px)"); // 2 columnas en tablets
  const cols = isSmall ? 1 : isMedium ? 2 : 3; // 3 columnas en escritorio

  const handleOpen = (img:any) => {
    setSelectedImage(img);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage("");
  };

  return (
    <Box>
      {/* Galería Responsive */}
      <ImageList variant="masonry" cols={cols} gap={8} sx={{ width: "100%", margin: "auto" }}>
        {itemData.map((item) => (
          <ImageListItem
            key={item.img}
            sx={{
              width: "100%",
              height: "250px",
              overflow: "hidden",
              cursor: "pointer",
            }}
            onClick={() => handleOpen(item.img)}
          >
            <img
              src={item.img}
              alt={item.title}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>

      {/* Modal de Imagen */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(5px)",
        }}
      >
        <Box
          sx={{
            position: "relative",
            bgcolor: "white",
            borderRadius: "10px",
            padding: "10px",
            boxShadow: 24,
            outline: "none",
            maxWidth: "90%",
            maxHeight: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "black",
              backgroundColor: "rgba(255,255,255,0.8)",
            }}
          >
            <CloseIcon />
          </IconButton>

          <img
            src={selectedImage}
            alt="Imagen ampliada"
            style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "5px" }}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default Gallery;
